import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
            关于亚洲天堂
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            关于我们的服务和亚洲旅行，您可能想了解的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  <a href={`#faq-${index}`} id={`faq-${index}`} className="no-underline">
                    {faq.question}
                  </a>
                </h4>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full border transition-all duration-300 ${
                  openIndex === index
                    ? 'bg-primary-500 border-primary-500 text-white rotate-180'
                    : 'border-foreground-300 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}